export default __webpack_public_path__ + "static/media/727.554b6440.jpg";